/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CommentTagType } from './CommentTagType';
import {
    CommentTagTypeFromJSON,
    CommentTagTypeFromJSONTyped,
    CommentTagTypeToJSON,
} from './CommentTagType';
import type { CreateOrUpdatePtwCommentDtoEntityType } from './CreateOrUpdatePtwCommentDtoEntityType';
import {
    CreateOrUpdatePtwCommentDtoEntityTypeFromJSON,
    CreateOrUpdatePtwCommentDtoEntityTypeFromJSONTyped,
    CreateOrUpdatePtwCommentDtoEntityTypeToJSON,
} from './CreateOrUpdatePtwCommentDtoEntityType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateOrUpdatePtwCommentDto
 */
export interface CreateOrUpdatePtwCommentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdatePtwCommentDto
     */
    entityId: string;
    /**
     * 
     * @type {CreateOrUpdatePtwCommentDtoEntityType}
     * @memberof CreateOrUpdatePtwCommentDto
     */
    entityType: CreateOrUpdatePtwCommentDtoEntityType | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdatePtwCommentDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdatePtwCommentDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {Array<CommentTagType>}
     * @memberof CreateOrUpdatePtwCommentDto
     */
    tags?: Array<CommentTagType> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdatePtwCommentDto
     */
    $type?: CreateOrUpdatePtwCommentDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdatePtwCommentDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoCommentsCreateOrUpdatePtwCommentDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Comments.CreateOrUpdatePtwCommentDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdatePtwCommentDtoTypeEnum = typeof CreateOrUpdatePtwCommentDtoTypeEnum[keyof typeof CreateOrUpdatePtwCommentDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdatePtwCommentDto interface.
 */
export function instanceOfCreateOrUpdatePtwCommentDto(value?: unknown): value is CreateOrUpdatePtwCommentDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdatePtwCommentDtoTypeEnum)[0];
}

export function CreateOrUpdatePtwCommentDtoFromJSON(json: any): CreateOrUpdatePtwCommentDto {
    return CreateOrUpdatePtwCommentDtoFromJSONTyped(json, false);
}

export function CreateOrUpdatePtwCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdatePtwCommentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityId': json['entityId'],
        'entityType': CreateOrUpdatePtwCommentDtoEntityTypeFromJSON(json['entityType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'] === null ? null : (json['tags'] as Array<any>).map(CommentTagTypeFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdatePtwCommentDtoToJSON(value?: CreateOrUpdatePtwCommentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'entityId': value.entityId,
        'entityType': CreateOrUpdatePtwCommentDtoEntityTypeToJSON(value.entityType),
        'description': value.description,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'tags': value.tags === undefined ? undefined : (value.tags === null ? null : (value.tags as Array<any>).map(CommentTagTypeToJSON)),
        '$type': value.$type,
    });
}

